/**
 * FOV Scheduling — ePrId encryption helpers.
 */
import { encryptToken, decryptToken } from './auth';

/**
 * Encrypts the `ePrId` so it is opaque in the URL. The returned value should be
 * `encodeURIComponent`-d by the caller before appending to a query string.
 */
export const encryptEPrId = (ePrId: string): Promise<string> => encryptToken(ePrId);

/**
 * Decrypts an encrypted `ePrId` query param. Returns `null` if the value is
 * missing or cannot be decrypted.
 */
export const decryptEPrId = async (encrypted: string): Promise<string | null> => {
  if (!encrypted) return null;
  try {
    return await decryptToken(encrypted);
  } catch (error) {
    console.error('decryptEPrId error:', error);
    return null;
  }
};
